
/**
 * AI 答疑官配置，在0331版本的AI面试列表中作为入口使用
 */
import IntelligentQA, { IS_DISABLED } from "@/lib/intelligentQA/intelligent-qa";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class AIQaConfigSelect extends Vue {
  @Prop({}) visible!: boolean;
  @Prop({}) ids!: any;

  title = "选择问题";

  form = {
    isDisabled: IS_DISABLED.ENABLE, // 默认只查询已启用的
    pageNum: 1,
    pageSize: 500
  };
  total = 0;
  tableData: any = [];

  @Watch("visible", { immediate: true })
  async getInfo(isShow: any) {
    if (isShow) {
      // 获取答疑官配置
      this.onSearch();
      // this.selectedTableData = this.info;
    } else {
      this.tableData = [] as any;
    }
  }

  onSearch() {
    this.form.pageNum = 1;
    this.getList();
  }

  onCurrentChange(value: number) {
    this.form.pageNum = value;
    this.getList();
  }

  async getList(value?: any) {
    const res = await IntelligentQA.list(this.form);
    console.log("🚀 ~ AIQaOfficerList ~ getList ~ res:", res);
    this.total = res.total;
    this.form.pageNum = res.pageNum;
    this.tableData = res.list;

    // 初始化已选中的问题列表状态
    this.toggleSelection();
  }

  // 面试配置：配置答疑官的 保存 按钮
  async onConfirmOk() {
    try {
      this.$emit("ok", this.selectedTableData);
      this.close();
    } catch (e) {
      console.log("🚀 ~ ApplicationRule ~ ok ~ e:", e);
    }
  }

  close() {
    this.$emit("update:visible", false);
  }

  // 移除单条记录
  removeQaItem(row: any) {
    (this.$refs.tableRef as any).toggleRowSelection(row, false);
  }

  // 在初始打开的时候，默认选中已选择的问题列表
  toggleSelection() {
    // 临时移除 selection-change 事件
    this.enableHandleSelectionChange = false;

    this.tableData.forEach((item: any) => {
      if (this.ids.includes(item.id)) {
        (this.$refs.tableRef as any).toggleRowSelection(item, true);
      }
    });

    // 初始化完成后重新添加事件监听器
    this.$nextTick(() => {
      this.enableHandleSelectionChange = true;
    });
  }

  // 已选中的列表
  selectedTableData = [] as any;
  enableHandleSelectionChange = false; // 新增一个标志，用于控制是否跳过handleSelectionChange处理
  handleSelectionChange(e: any) {
    console.log("🚀 ~ AIQaConfigSelect ~ handleSelectionChange ~ e:", e);
    if (this.enableHandleSelectionChange) {
      this.selectedTableData = e || [];
    }
  }
}
